import React from 'react';
import { GiftIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    title: 'Biblioteca Premium de Modelos Laborales™',
    details: 'Más de 100 modelos editables.',
    price: 'AR$ 19.990'
  }, {
    title: 'Cláusulas Laborales PRO™',
    details: 'Formularios, checklists, planillas y organización de expedientes.',
    price: 'AR$ 14.990'
  }, {
    title: 'Escritos Urgentes Laborales',
    details: 'Escritos urgentes laborales con medidas cautelares, recursos, pronto despacho, habilitaciones, oficios y presentaciones procesales completamente redactadas',
    price: 'AR$ 9.990'
  }, {
    title: '100 Formularios, Checklists y Herramientas Listas para Usar',
    details: 'Fichas de clientes, entrevistas, control de plazos, seguimiento de casos, convenios, informes y planillas listas para completar y utilizar desde el primer día.',
    price: 'AR$ 7.990'
  }];
  return <section className="border-y border-white/10 bg-charcoal px-5 py-14 md:px-8 md:py-20" data-id="element-26" data-mp="3id55p9kqj9cd">
      <div className="mx-auto max-w-5xl" data-id="element-27" data-mp="3deadxi4siag4">
        <FadeIn className="text-center" data-id="element-28" data-mp="3dd8xey508vr0">
          <div className="mx-auto flex w-fit items-center gap-2 text-accent" data-id="element-29" data-mp="3r6zzjlgepdcp">
            <GiftIcon size={18} aria-hidden="true" data-id="element-30" data-mp="3n5eqkb6ztj7s" />
            <p className="text-sm font-bold uppercase tracking-[0.18em]" data-id="element-31" data-mp="3n5ohc0zv3uej">
              Bonos exclusivos
            </p>
          </div>
          <h2 className="mt-2 font-display text-3xl font-bold text-white md:text-4xl" data-id="element-32" data-mp="2ugh9gbeipsgm">
            4 recursos adicionales incluidos hoy
          </h2>
          <p className="mt-3 text-sm text-stone-400" data-id="element-33" data-mp="38h1qp34sbg80">
            Sin costo adicional con tu tratado.
          </p>
        </FadeIn>

        <div className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-34" data-mp="33j9ye8089s3a">
          {bonuses.map((bonus, index) => <FadeIn key={bonus.title} delay={index * 0.06} data-id="element-35" data-mp="nruj0hsa7t20" data-mpi={index}>
              <article className="relative border border-accent/30 bg-ink p-6" data-id="element-36" data-mp="iq57z2527fdx">
                <span className="text-xs font-bold uppercase tracking-[0.18em] text-accent" data-id="element-37" data-mp="3cjpoz15zwyp5">
                  Bono {index + 1}
                </span>
                <h3 className="mt-3 font-display text-xl font-bold text-white" data-id="element-38" data-mp="3hk3wmi3oq6mn">
                  {bonus.title}
                </h3>
                <p className="mt-3 min-h-10 text-sm leading-relaxed text-stone-400" data-id="element-39" data-mp="3qj7kdzdsra7h">
                  {bonus.details}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-white/10 pt-4" data-id="element-40" data-mp="2ttzvqihvskzc">
                  <span className="text-sm text-stone-500 line-through" data-id="element-41" data-mp="2xujq5eb2lahs">
                    {bonus.price}
                  </span>
                  <span className="bg-accent px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-ink" data-id="element-42" data-mp="37jtkz1xat79l">
                    Gratis
                  </span>
                </div>
              </article>
            </FadeIn>)}
        </div>

        <p className="mx-auto mt-7 max-w-2xl text-center text-sm leading-relaxed text-stone-400" data-id="element-43" data-mp="2f27qx0fpqpbv">
          Todo está incluido hoy para que puedas resolver expedientes con mayor
          rapidez, seguridad jurídica y respaldo profesional.
        </p>
      </div>
    </section>;
}